import React from 'react';
import { Lightbulb, Presentation, GraduationCap, LineChart } from 'lucide-react';
import SocialLinks from './SocialLinks';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Services = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const services = [
    {
      title: t.services.consulting.title,
      description: t.services.consulting.description,
      icon: Lightbulb,
      gradient: 'from-cyan-500 to-blue-500'
    },
    {
      title: t.services.outreach.title,
      description: t.services.outreach.description,
      icon: Presentation,
      gradient: 'from-purple-500 to-pink-500'
    },
    {
      title: t.services.training.title,
      description: t.services.training.description,
      icon: GraduationCap,
      gradient: 'from-cyan-500 to-purple-500'
    },
    {
      title: t.services.strategy.title,
      description: t.services.strategy.description,
      icon: LineChart,
      gradient: 'from-blue-500 to-purple-500'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-cyan-50 via-white to-purple-50">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center mb-4 bg-gradient-to-r from-cyan-500 to-purple-600 bg-clip-text text-transparent">
          {t.services.title}
        </h2>
        <p className="text-xl text-center text-gray-600 mb-12">
          {t.services.subtitle}
        </p>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white p-6 rounded-xl border border-purple-100 hover:border-cyan-300 transition-all hover:shadow-lg"
            >
              <div className={`bg-gradient-to-r ${service.gradient} p-3 rounded-lg inline-block mb-4`}>
                <service.icon className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-3 group-hover:text-purple-600 transition-colors">
                {service.title}
              </h3>
              <p className="text-gray-600">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mb-12">
          <h3 className="text-2xl font-semibold mb-6">{t.services.followUs}</h3>
          <div className="flex justify-center">
            <SocialLinks iconClassName="w-10 h-10" />
          </div>
        </div>

        <div className="text-center">
          <a 
            href="#contact" 
            className="inline-flex items-center px-8 py-3 bg-gradient-to-r from-cyan-500 to-purple-600 text-white rounded-lg hover:from-cyan-600 hover:to-purple-700 transition-all"
          >
            {t.services.cta}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;